var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "shipping-zones" } },
    [
      _c(
        "b-card",
        {
          staticClass: "d-inline-flex",
          attrs: { header: "Postage Costs", "body-class": "p-0" },
        },
        [
          _c("b-table", {
            staticClass: "mb-0",
            attrs: {
              id: "zone-price-table",
              fields: _vm.fields,
              items: _vm.items,
              small: "",
              bordered: "",
              striped: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }